import { convertDateTime, toDateFieldValue } from 'utils/time';

export const getSeasonBusinessRules = (seasonsData) => {
  const active = seasonsData.find((s) => s.status === 'Active');
  const draft = seasonsData.find((s) => s.status === 'Draft');
  const sortedSeasons = [...seasonsData].sort((a, b) => {
    if (a.status === 'Draft') return -1;
    if (b.status === 'Draft') return 1;
    if (a.status === 'Active') return -1;
    if (b.status === 'Active') return 1;
    return new Date(b.startDate) - new Date(a.startDate);
  });
  return {
    activeSeason: active ? formatSeasonDates(active) : null,
    draftSeason: draft ? formatSeasonDates(draft) : null,
    sortedSeasons: sortedSeasons.map((season) => formatSeasonDates(season)),
    rules: {
      canAddNewSeason: !draft,
      canStartNewSeason: canStartNewSeason(active, draft),
      toolTipAddSeason: !draft
        ? 'Create a new draft season'
        : 'Only one draft season allowed at a time',
      toolTipStartNewSeason: toolTipStartNewSeason(active, draft),
    },
  };
};

const canStartNewSeason = (activeSeason, draftSeason) => {
  if (!activeSeason || !draftSeason) return false;

  const today = new Date();
  const activeEndDate = new Date(activeSeason.endDate);
  return today > activeEndDate;
};

const toolTipStartNewSeason = (activeSeason, draftSeason) => {
  if (canStartNewSeason(activeSeason, draftSeason)) {
    return `Transition the Draft season to become the new active season. Requires Admin PIN.`;
  } else {
    if (activeSeason) {
      const activeEnd = new Date(activeSeason.endDate);
      const daysRemaining = Math.ceil(
        (activeEnd - new Date()) / (1000 * 60 * 60 * 24)
      );
      return `Current season must end before starting a new one (${daysRemaining} days remaining)`;
    } else {
      return 'No draft season available';
    }
  }
};

const formatSeasonDates = (season) => {
  // Add null check to prevent errors
  if (!season) return null;

  return {
    ...season,
    ageCalculationDate: convertDateTime(season.ageCalculationDate).date,
    startDate: convertDateTime(season.startDate).date,
    endDate: convertDateTime(season.endDate).date,
    // The dates as the server stores them ("YYYY-MM-DD"), for the season form and its checks. The two above are
    // text for reading only.
    startDateValue: toDateFieldValue(season.startDate),
    endDateValue: toDateFieldValue(season.endDate),
  };
};
